const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const API_BASE_URL = configuredApiBaseUrl === '__RELATIVE__'
  ? ''
  : configuredApiBaseUrl ?? 'http://localhost:5244';

export default API_BASE_URL;
